// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Invoice,
    InvoiceFromJSON,
    InvoiceToJSON,
    ProviderAIPhone,
    ProviderAIPhoneFromJSON,
    ProviderAIPhoneToJSON,
    ProviderClaim,
    ProviderClaimFromJSON,
    ProviderClaimToJSON,
    ProviderClaimEligibility,
    ProviderClaimEligibilityFromJSON,
    ProviderClaimEligibilityToJSON,
    ProviderClaimPayment,
    ProviderClaimPaymentFromJSON,
    ProviderClaimPaymentToJSON,
    ProviderClaimTransmission,
    ProviderClaimTransmissionFromJSON,
    ProviderClaimTransmissionToJSON,
    ProviderCoding,
    ProviderCodingFromJSON,
    ProviderCodingToJSON,
    ProviderCollectionPayment,
    ProviderCollectionPaymentFromJSON,
    ProviderCollectionPaymentToJSON,
    ProviderComment,
    ProviderCommentFromJSON,
    ProviderCommentToJSON,
    ProviderDocument,
    ProviderDocumentFromJSON,
    ProviderDocumentToJSON,
    ProviderHL7Message,
    ProviderHL7MessageFromJSON,
    ProviderHL7MessageToJSON,
    ProviderInstitutionalClaim,
    ProviderInstitutionalClaimFromJSON,
    ProviderInstitutionalClaimToJSON,
    ProviderLetter,
    ProviderLetterFromJSON,
    ProviderLetterToJSON,
    ProviderMail,
    ProviderMailFromJSON,
    ProviderMailToJSON,
    ProviderMessage,
    ProviderMessageFromJSON,
    ProviderMessageToJSON,
    ProviderPhone,
    ProviderPhoneFromJSON,
    ProviderPhoneToJSON,
    ProviderProfessionalClaim,
    ProviderProfessionalClaimFromJSON,
    ProviderProfessionalClaimToJSON,
    ProviderReceiveFax,
    ProviderReceiveFaxFromJSON,
    ProviderReceiveFaxToJSON,
    ProviderSendEmail,
    ProviderSendEmailFromJSON,
    ProviderSendEmailToJSON,
    ProviderSendFax,
    ProviderSendFaxFromJSON,
    ProviderSendFaxToJSON,
    ProviderStatus,
    ProviderStatusFromJSON,
    ProviderStatusToJSON,
    ProviderWorkerFunction,
    ProviderWorkerFunctionFromJSON,
    ProviderWorkerFunctionToJSON,
} from './';

/**
 * Claim details
 * @export
 * @interface ProviderClaimDetails
 */
export interface ProviderClaimDetails {
    /**
     * 
     * OpenAPI data type: {ProviderClaim}
     * @type {ProviderClaim}
     * @memberof ProviderClaimDetails
     */
    claim?: ProviderClaim;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCoding>}
     * @memberof ProviderClaimDetails
     */
    codings?: Array<ProviderCoding>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderWorkerFunction>}
     * @memberof ProviderClaimDetails
     */
    workerFunctions?: Array<ProviderWorkerFunction>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderHL7Message>}
     * @memberof ProviderClaimDetails
     */
    hl7s?: Array<ProviderHL7Message>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<Invoice>}
     * @memberof ProviderClaimDetails
     */
    invoices?: Array<Invoice>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCollectionPayment>}
     * @memberof ProviderClaimDetails
     */
    collectionPayments?: Array<ProviderCollectionPayment>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderClaimPayment>}
     * @memberof ProviderClaimDetails
     */
    payments?: Array<ProviderClaimPayment>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderClaimEligibility>}
     * @memberof ProviderClaimDetails
     */
    eligibilities?: Array<ProviderClaimEligibility>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderStatus>}
     * @memberof ProviderClaimDetails
     */
    statuses?: Array<ProviderStatus>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderProfessionalClaim>}
     * @memberof ProviderClaimDetails
     */
    professionals?: Array<ProviderProfessionalClaim>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderClaimTransmission>}
     * @memberof ProviderClaimDetails
     */
    transmissions?: Array<ProviderClaimTransmission>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderInstitutionalClaim>}
     * @memberof ProviderClaimDetails
     */
    institutionals?: Array<ProviderInstitutionalClaim>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderDocument>}
     * @memberof ProviderClaimDetails
     */
    documents?: Array<ProviderDocument>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderSendFax>}
     * @memberof ProviderClaimDetails
     */
    sendFaxes?: Array<ProviderSendFax>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderReceiveFax>}
     * @memberof ProviderClaimDetails
     */
    receiveFaxes?: Array<ProviderReceiveFax>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderLetter>}
     * @memberof ProviderClaimDetails
     */
    letters?: Array<ProviderLetter>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderPhone>}
     * @memberof ProviderClaimDetails
     */
    phones?: Array<ProviderPhone>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderAIPhone>}
     * @memberof ProviderClaimDetails
     */
    aiPhones?: Array<ProviderAIPhone>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderMail>}
     * @memberof ProviderClaimDetails
     */
    mails?: Array<ProviderMail>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderSendEmail>}
     * @memberof ProviderClaimDetails
     */
    sendEmails?: Array<ProviderSendEmail>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderMessage>}
     * @memberof ProviderClaimDetails
     */
    messages?: Array<ProviderMessage>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderComment>}
     * @memberof ProviderClaimDetails
     */
    comments?: Array<ProviderComment>;
}

export function ProviderClaimDetailsFromJSON(json: any): ProviderClaimDetails {
    return {
            'claim': !exists(json, 'claim') ? undefined : ProviderClaimFromJSON(json['claim']),
            'codings': !exists(json, 'codings') ? undefined : (json['codings'] as Array<any>).map(ProviderCodingFromJSON),
            'workerFunctions': !exists(json, 'workerFunctions') ? undefined : (json['workerFunctions'] as Array<any>).map(ProviderWorkerFunctionFromJSON),
            'hl7s': !exists(json, 'hl7s') ? undefined : (json['hl7s'] as Array<any>).map(ProviderHL7MessageFromJSON),
            'invoices': !exists(json, 'invoices') ? undefined : (json['invoices'] as Array<any>).map(InvoiceFromJSON),
            'collectionPayments': !exists(json, 'collectionPayments') ? undefined : (json['collectionPayments'] as Array<any>).map(ProviderCollectionPaymentFromJSON),
            'payments': !exists(json, 'payments') ? undefined : (json['payments'] as Array<any>).map(ProviderClaimPaymentFromJSON),
            'eligibilities': !exists(json, 'eligibilities') ? undefined : (json['eligibilities'] as Array<any>).map(ProviderClaimEligibilityFromJSON),
            'statuses': !exists(json, 'statuses') ? undefined : (json['statuses'] as Array<any>).map(ProviderStatusFromJSON),
            'professionals': !exists(json, 'professionals') ? undefined : (json['professionals'] as Array<any>).map(ProviderProfessionalClaimFromJSON),
            'transmissions': !exists(json, 'transmissions') ? undefined : (json['transmissions'] as Array<any>).map(ProviderClaimTransmissionFromJSON),
            'institutionals': !exists(json, 'institutionals') ? undefined : (json['institutionals'] as Array<any>).map(ProviderInstitutionalClaimFromJSON),
            'documents': !exists(json, 'documents') ? undefined : (json['documents'] as Array<any>).map(ProviderDocumentFromJSON),
            'sendFaxes': !exists(json, 'sendFaxes') ? undefined : (json['sendFaxes'] as Array<any>).map(ProviderSendFaxFromJSON),
            'receiveFaxes': !exists(json, 'receiveFaxes') ? undefined : (json['receiveFaxes'] as Array<any>).map(ProviderReceiveFaxFromJSON),
            'letters': !exists(json, 'letters') ? undefined : (json['letters'] as Array<any>).map(ProviderLetterFromJSON),
            'phones': !exists(json, 'phones') ? undefined : (json['phones'] as Array<any>).map(ProviderPhoneFromJSON),
            'aiPhones': !exists(json, 'aiPhones') ? undefined : (json['aiPhones'] as Array<any>).map(ProviderAIPhoneFromJSON),
            'mails': !exists(json, 'mails') ? undefined : (json['mails'] as Array<any>).map(ProviderMailFromJSON),
            'sendEmails': !exists(json, 'sendEmails') ? undefined : (json['sendEmails'] as Array<any>).map(ProviderSendEmailFromJSON),
            'messages': !exists(json, 'messages') ? undefined : (json['messages'] as Array<any>).map(ProviderMessageFromJSON),
            'comments': !exists(json, 'comments') ? undefined : (json['comments'] as Array<any>).map(ProviderCommentFromJSON),
    };

}

export function ProviderClaimDetailsToForm(value?: ProviderClaimDetails): any {
    let jsonVal = ProviderClaimDetailsToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderClaimDetailsToJSON(value?: ProviderClaimDetails): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'claim': ProviderClaimToJSON(value.claim),
            'codings': (value.codings === undefined || value.codings === null) ? undefined : (value.codings as Array<any>).map(ProviderCodingToJSON),
            'workerFunctions': (value.workerFunctions === undefined || value.workerFunctions === null) ? undefined : (value.workerFunctions as Array<any>).map(ProviderWorkerFunctionToJSON),
            'hl7s': (value.hl7s === undefined || value.hl7s === null) ? undefined : (value.hl7s as Array<any>).map(ProviderHL7MessageToJSON),
            'invoices': (value.invoices === undefined || value.invoices === null) ? undefined : (value.invoices as Array<any>).map(InvoiceToJSON),
            'collectionPayments': (value.collectionPayments === undefined || value.collectionPayments === null) ? undefined : (value.collectionPayments as Array<any>).map(ProviderCollectionPaymentToJSON),
            'payments': (value.payments === undefined || value.payments === null) ? undefined : (value.payments as Array<any>).map(ProviderClaimPaymentToJSON),
            'eligibilities': (value.eligibilities === undefined || value.eligibilities === null) ? undefined : (value.eligibilities as Array<any>).map(ProviderClaimEligibilityToJSON),
            'statuses': (value.statuses === undefined || value.statuses === null) ? undefined : (value.statuses as Array<any>).map(ProviderStatusToJSON),
            'professionals': (value.professionals === undefined || value.professionals === null) ? undefined : (value.professionals as Array<any>).map(ProviderProfessionalClaimToJSON),
            'transmissions': (value.transmissions === undefined || value.transmissions === null) ? undefined : (value.transmissions as Array<any>).map(ProviderClaimTransmissionToJSON),
            'institutionals': (value.institutionals === undefined || value.institutionals === null) ? undefined : (value.institutionals as Array<any>).map(ProviderInstitutionalClaimToJSON),
            'documents': (value.documents === undefined || value.documents === null) ? undefined : (value.documents as Array<any>).map(ProviderDocumentToJSON),
            'sendFaxes': (value.sendFaxes === undefined || value.sendFaxes === null) ? undefined : (value.sendFaxes as Array<any>).map(ProviderSendFaxToJSON),
            'receiveFaxes': (value.receiveFaxes === undefined || value.receiveFaxes === null) ? undefined : (value.receiveFaxes as Array<any>).map(ProviderReceiveFaxToJSON),
            'letters': (value.letters === undefined || value.letters === null) ? undefined : (value.letters as Array<any>).map(ProviderLetterToJSON),
            'phones': (value.phones === undefined || value.phones === null) ? undefined : (value.phones as Array<any>).map(ProviderPhoneToJSON),
            'aiPhones': (value.aiPhones === undefined || value.aiPhones === null) ? undefined : (value.aiPhones as Array<any>).map(ProviderAIPhoneToJSON),
            'mails': (value.mails === undefined || value.mails === null) ? undefined : (value.mails as Array<any>).map(ProviderMailToJSON),
            'sendEmails': (value.sendEmails === undefined || value.sendEmails === null) ? undefined : (value.sendEmails as Array<any>).map(ProviderSendEmailToJSON),
            'messages': (value.messages === undefined || value.messages === null) ? undefined : (value.messages as Array<any>).map(ProviderMessageToJSON),
            'comments': (value.comments === undefined || value.comments === null) ? undefined : (value.comments as Array<any>).map(ProviderCommentToJSON),
    };
}


